var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarFromWarehouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_833_854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4987 7.3335C16.4987 4.29475 14.0374 1.8335 10.9987 1.8335C7.95995 1.8335 5.4987 4.29475 5.4987 7.3335C5.4987 11.4585 10.9987 17.4168 10.9987 17.4168C10.9987 17.4168 16.4987 11.4585 16.4987 7.3335ZM9.16536 7.3335C9.16536 6.32058 9.98578 5.50016 10.9987 5.50016C12.0116 5.50016 12.832 6.32058 12.832 7.3335C12.832 8.34641 12.0116 9.16683 10.9987 9.16683C9.98578 9.16683 9.16536 8.34641 9.16536 7.3335ZM4.58203 18.3335V20.1668H17.4154V18.3335H4.58203Z",
    fill: "#14AC63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_833_854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarFromWarehouse);
export default __webpack_public_path__ + "static/media/FarFromWarehouse.7c90abfb2bd60a5b17e849b042312458.svg";
export { ForwardRef as ReactComponent };